<template>
  <div
    id="membership"
    class="page-content membership"
  >
    <div
      v-if="hasSpecialPermission"
      class="row"
    >
      <div class="col-sm-6">
        <manual-update-plan />
        <refund-subscription />
        <deactivate-account />
        <generate-retention-link />
      </div>

      <div class="col-sm-6">
        <update-plan-without-charge />
        <reactivate-account />
        <apply-plan-addon />
      </div>
    </div>

    <div
      v-else
      class="row"
    >
      <div class="col-sm-6">
        <manual-update-plan />
        <reactivate-account />
        <deactivate-account />
      </div>
    </div>

    <user-plan-history />
    <caller-plan-addons />
  </div>
</template>

<script setup lang="ts">
import { nextTick, toRefs, onMounted, computed, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';
import { useProfile } from '@/use/profile';

const DeactivateAccount = defineAsyncComponent(() => import('./Membership/DeactivateAccount.vue') as any);
const GenerateRetentionLink = defineAsyncComponent(() => import('./Membership/GenerateRetentionLink.vue') as any);
const ReactivateAccount = defineAsyncComponent(() => import('./Membership/ReactivateAccount.vue') as any);
const ManualUpdatePlan = defineAsyncComponent(() => import('./Membership/ManualUpdatePlan.vue') as any);
const UpdatePlanWithoutCharge = defineAsyncComponent(() => import('./Membership/UpdatePlanWithoutCharge.vue') as any);
const RefundSubscription = defineAsyncComponent(() => import('./Membership/RefundSubscription.vue') as any);
const UserPlanHistory = defineAsyncComponent(() => import('./UserPlan/UserPlanHistory.vue') as any);
const CallerPlanAddons = defineAsyncComponent(() => import('./UserPlan/CallerPlanAddons.vue') as any);
const ApplyPlanAddon = defineAsyncComponent(() => import('./UserPlan/ApplyPlanAddon.vue') as any);

const { userRoles } = useProfile();
const { isAdmin, isSupervisor, isDirector } = toRefs(userRoles);

const hasSpecialPermission = computed(() => isAdmin.value || isSupervisor.value || isDirector.value);

onMounted(async () => {
  const route = useRoute();
  await nextTick();
  util.moveScrollComponent(route.hash);
});
</script>
